import script from "./VagasView.vue?vue&type=script&setup=true&lang=js"
export * from "./VagasView.vue?vue&type=script&setup=true&lang=js"

import "./VagasView.vue?vue&type=style&index=0&id=53265240&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53265240"]])

export default __exports__